import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';
import MainDrawer from './Main';
import { theme } from '@chakra-ui/react';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 70;

const Main = styled('div')(({ theme }) => ({
  // flexGrow: 1,
  // justifyContent: 'center',
  // display: 'flex',
  // flexDirection:'column',
  // overflow: 'auto',
  background: theme.palette.background.paper,
  width: '100%',
  // height: '100%',
  // paddingTop: APP_BAR_MOBILE + 24,
  // paddingBottom: theme.spacing(10),
  // paddingBottom: 0,
  // [theme.breakpoints.up('lg')]: {
  //   paddingTop: APP_BAR_DESKTOP + 24,
  //   paddingLeft: theme.spacing(2),
  //   paddingRight: theme.spacing(2),
  // },
}));
const StyledRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '100%',
  overflow: 'auto',
  backgroundColor: theme.palette.background.default,
  justifyContent: 'center',
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.4em',
    },
    '*::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '1px solid slategrey',
    },
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);

  return (
    <StyledRoot>
      {/* <Header openNav={open} onOpenNav={() => setOpen(!open)} /> */}
      <Main>
        <MainDrawer Nav={Nav} Outlet={<Outlet />} />
        {/* <Nav openNav={open} onCloseNav={() => setOpen(!open)} />
        <Outlet /> */}
      </Main>
    </StyledRoot>
  );
}
